import query from './APIServices'

export interface costCategory {
  id: number
  name: string
  description: string
}

export const getCostCategories = async (params?: { search?: string }) => {
  const searchParams = params?.search ? `?search=${params.search}` : ''
  const response = await query.get(
    `/administration/fixedcostcategory${searchParams}`
  )
  return response?.data.items as costCategory[]
}
